<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      <v-flex md12>
        <core-table ref="deployTable" :config="config" title="REDCap Projects list" @deploy="deploy">
            <template slot='headerActions'>

            <v-tooltip
              top>
              <template
                slot="activator"
                slot-scope="{ on }">
                 <v-btn
                  v-on="on"
                  color="secondary"
                  @click="deploy_all()">
                  <v-icon>mdi-cloud-upload</v-icon>
                </v-btn>
              </template>
              <span>Deploy ALL</span>
            </v-tooltip>

            </template>
        </core-table>
      </v-flex>
    </v-layout>

    <app-deploy-modal  v-model="deployModal" :items="items" @deployed="deployed"/>

  </v-container>
  
</template>

<script>

import config from './config_index.js'
import {getList} from '@/api/base_entity.js'


export default {
  data () {
    return { 
      config,
      items: [],
      deployModal : false
    }
  },
  created() {
  },
  beforeDestroy () {
  },
  methods: {
    deploy(item) {
      this.items = [item]
      this.deployModal = true
    },
    async deploy_all() {
      const ret = await getList('redcap_deploy', {}, {rowsPerPage:-1})
      this.items = ret.data
      this.deployModal = true
    },
    deployed() {
      this.$refs.deployTable.getData();
    }
  }
}
</script>
